/**
 * History Page Component
 */
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { History } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import TransactionItem from '../components/TransactionItem';
import { ErrorState } from '../components/ErrorState';
import { classifyError } from '../lib/apiError';
import { API_URL, BACKEND_URL } from '../config';


const HistoryPage = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => { fetchTransactions(); }, []);

  const fetchTransactions = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem("auth_token");
      const response = await axios.get(`${API_URL}/transactions`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTransactions(response.data);
    } catch (err) {
      const classified = classifyError(err);
      setError(classified);
      toast.error(classified.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="space-y-4">
        <div className="h-8 w-48 loading-shimmer rounded" />
        {[1, 2, 3].map((i) => <div key={i} className="h-20 loading-shimmer rounded-xl" />)}
      </div>
    );
  }

  if (error) {
    return <ErrorState error={error} onRetry={fetchTransactions} />;
  }

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Your bill history</h1>
        <p className="text-muted-foreground text-sm">Every electricity, water, and TV payment in one place.</p>
      </div>
      {transactions.length > 0 ? (
        <div className="space-y-3">
          {transactions.map((tx) => <TransactionItem key={tx.id} transaction={tx} />)}
        </div>
      ) : (
        <div className="text-center py-12">
          <History className="w-16 h-16 mx-auto mb-4 text-muted-foreground/50" />
          <p className="text-muted-foreground">No bills paid yet — your first one is a tap away.</p>
        </div>
      )}
    </motion.div>
  );
};

export default HistoryPage;